import { render } from "./TranscriptionText.vue?vue&type=template&id=2d40e42b"
import script from "./TranscriptionText.vue?vue&type=script&lang=js"
export * from "./TranscriptionText.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__